<template>
  <div class="aboutus">
    <basepanel>
      <div class="outer-box">
        <!-- horizontal-box 手机端加上该样式 -->
        <div :class="{ 'inner-box': true, 'horizontal-box': phoneshow }">
          <el-tabs
            v-model="activeIndex"
            @tab-click="handleClick"
            class="horizontal-tabs"
          >
            <!-- <el-tab-pane label="核心技术" name="1"></el-tab-pane> -->
            <el-tab-pane label="人才招聘" name="2"></el-tab-pane>
            <el-tab-pane label="联系我们" name="3"></el-tab-pane>
          </el-tabs>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical"
            @select="handleSelect"
          >
            <!-- <el-menu-item index="1">
              <span
                :class="{ side: true, 'side-active': activeIndex == 1 }"
              ></span>
              <span slot="title">核心技术</span>
            </el-menu-item> -->
            <el-menu-item index="2">
              <span
                :class="{ side: true, 'side-active': activeIndex == 2 }"
              ></span>
              <span slot="title">加入我们</span>
            </el-menu-item>
            <el-menu-item index="3">
              <span
                :class="{ side: true, 'side-active': activeIndex == 3 }"
              ></span>
              <span slot="title">联系我们</span>
            </el-menu-item>
          </el-menu>

          <div class="all-modules">
            <!-- 核心技术 -->
            <!-- <div v-if="activeIndex == 1" class="core">
              <div>
                <div
                  class="sec"
                  v-for="(val, index) in coreLists"
                  :key="index"
                  :class="{
                    special: phoneshow
                      ? (index + 1) % 2 == 0
                      : (index + 1) % 3 == 0,
                  }"
                >
                  <img class="top" :src="val.defineUrl" alt="" />
                  <p class="title">{{ val.title }}</p>
                </div>
              </div>
              <div class="hint">
                <span class="iconfont">&#xe613;</span>
                部分软著
              </div>
            </div> -->
            <div v-if="activeIndex == 2" class="recruitment">
              <div>
                <ul>
                  <li
                    v-for="(val, index) in jobList"
                    :key="index"
                    :class="{ active: index == selectIndex }"
                    @click="selectJob(index)"
                  >
                    {{ val.title }}
                  </li>
                </ul>
                <div class="info" v-if="select">
                  <h2>岗位职责：</h2>
                  <div v-for="text in select.textarea" :key="text.id">
                    {{ text }}
                  </div>
                  <h2>任职资格：</h2>
                  <div v-for="exp in select.explain" :key="exp.id">
                    {{ exp }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeIndex == 3" class="contactus">
              <div class="content">
                <div class="cont-left" id="allmap">
                  <baidu-map id="allmap" :center="markerPoint" :zoom="20">
                    <bm-navigation
                      anchor="BMAP_ANCHOR_TOP_RIGHT"
                    ></bm-navigation>
                    <bm-marker :position="markerPoint"></bm-marker>
                  </baidu-map>
                  <!-- <img
                    class="pos-bg"
                    src="../assets/images/aboutus/map.png"
                    alt=""
                  />
                  <div
                    v-for="(val, index) in placeNum"
                    :key="index"
                    :class="'pos pos' + (index + 1)"
                    @click="selectAddr(index)"
                    @mouseenter="selectAddr(index)"
                  >
                    <img
                      v-if="currIndex == index"
                      src="../assets/images/aboutus/selected.png"
                      alt="选中"
                    />
                    <img
                      v-else
                      src="../assets/images/aboutus/unselect.png"
                      alt="未选中"
                    />
                  </div> -->
                </div>
                <div class="cont-right">
                  <div class="left">
                    <p>联系人：{{ this.selectOne.people }}</p>
                    <p>联系电话：{{ this.selectOne.number }}</p>
                    <p>联系邮箱：{{ this.selectOne.email }}</p>
                    <p>地址：{{ this.selectOne.Adress }}</p>
                  </div>
                  <div class="right">
                    <img :src="selectOne.defineUrl" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </basepanel>
  </div>
</template>

<script>
import basepanel from "../components/BasePanel";
import { listNextWithFilter, view } from "../api/index";
export default {
  name: "aboutus",
  components: { basepanel },
  data() {
    return {
      activeIndex: "2", //1核心技术，2人才招聘，3联系我们
      // 核心技术
      coreLists: [],
      // 加入我们
      selectIndex: 0, //默认选中的索引
      jobList: [],
      content: [],
      select: "",
      textarea: [],
      explain: [],
      // 联系我们
      // contact: [],
      // placeNum: 5,
      // Ids: ["", "", "", this.$map.cq, ""],
      // currIndex: 3, // 0呼和浩特  1沈阳  2太原  3重庆  4杭州
      selectOne: {},
      markerPoint: { lng: 106.51584, lat: 29.620552 },
      screenWidth: document.body.clientWidth,
    };
  },
  computed: {
    phoneshow: function () {
      return this.screenWidth < 768 ? true : false;
    },
  },
  methods: {
    handleClick(tab) {
      this.activeIndex = (parseInt(tab.index) + 1).toString();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
    async getCoreLists() {
      let send = {
        url: {
          page: 1,
          size: 30,
        },
        data: {
          categoryIdList: [this.$map.corecategoryId],
          needData: true,
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let lists = res.data;
        lists.map((val) => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
        });
        this.coreLists = lists;
        // new WOW().init();
      } else {
        console.log(res.msg);
      }
    },

    selectJob(index) {
      this.selectIndex = index;
      if (!this.content[index]) {
        this.getJobsDetail(this.jobList[index].id);
      } else {
        this.select = this.content[this.selectIndex];
      }
    },
    async getJobs() {
      let send = {
        url: {
          page: 1,
          size: 20,
        },
        data: {
          categoryIdList: [this.$map.recruitcategoryId],
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        this.jobList = res.data;
        this.getJobsDetail(this.jobList[0].id);
      } else {
        console.log(res.msg);
      }
    },
    // 获取职位详情
    async getJobsDetail(id) {
      let send = {
        url: {
          id,
        },
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        data.textarea = data.textarea.split("\n");
        data.explain = data.explain.split("\n");
        this.content[this.selectIndex] = data;
        this.select = data;
      } else {
        console.log(res.msg);
      }
    },

    // selectAddr(index) {
    //   this.currIndex = index;
    //   if (!this.contact[this.currIndex]) {
    //     this.getData(this.Ids[this.currIndex]);
    //   } else {
    //     this.selectOne = this.contact[this.currIndex];
    //   }
    // },
    async getData(id) {
      let send = {
        url: {
          id,
        },
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        this.$set(data, "defineUrl", this.$srcHandle(data.imageclipper));
        // this.contact[this.currIndex] = data;
        this.selectOne = data;
      } else {
        console.log(res.msg);
      }
    },
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.getCoreLists();
    this.getJobs();
    // this.getData(this.Ids[this.currIndex]);
    this.getData(this.$map.cq);
  },
};
</script>

<style scoped lang="less">
.aboutus {
  .inner-box {
    display: flex;
    justify-content: space-between;
    .horizontal-tabs {
      display: none;
    }
    .all-modules {
      width: 100%;
      padding-left: 6%;
      .core {
        .sec {
          display: inline-block;
          vertical-align: top;
          // cursor: pointer;
          margin-right: 2%;
          text-decoration: none;
          color: #000;
          // margin-bottom: 20px;
          // background-color: #fff;
          // &:hover {
          //   box-shadow: 0 0 16px #0e6cb6;
          //   transition: all 0.3s ease;
          // }
          .top {
            width: 100%;
          }
          .title {
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            text-align: center;
          }
        }
        .special {
          margin-right: 0;
        }
        .hint {
          text-align: right;
          margin-top: 6px;
          letter-spacing: 1px;
          @font-face {
            font-family: "iconfont"; /* Project id  */
            src: url("../assets/iconfont.ttf?t=1620782934324")
              format("truetype");
          }

          .iconfont {
            font-family: "iconfont" !important;
            font-size: 16px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          .icon-weibiaoti-:before {
            content: "\e613";
          }
        }
      }
      .recruitment {
        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          li {
            text-align: center;
            // border: 1px solid #010439;
            cursor: pointer;
            // padding: 16px;
            background-color: #e3eaf0;
            border-radius: 6px;
            color: #333333;
            // margin-right: 20px;
            // margin-bottom: 20px;
          }
          .active {
            color: #ffffff;
            background-color: #0e6cb6;
          }
        }
        // .info {
        //   // background-color: #eeeeee;
        //   // padding: 16px;
        //   h2 {
        //     // line-height: 50px;
        //     // font-size: 18px;
        //     // font-weight: bold;
        //   }
        //   div {
        //     // line-height: 40px;
        //   }
        // }
      }
      .contactus {
        .content {
          // display: flex;
          // flex-wrap: wrap;
          // justify-content: space-between;
          .cont-left {
            #allmap {
              // height: 546px;
              /* 去除百度地图版权那行字 和 百度logo */
              /deep/.BMap_cpyCtrl {
                display: none !important;
              }
              /deep/.anchorBL {
                display: none !important;
              }
            }
            // position: relative;
            // .pos-bg {
            //   width: 100%;
            // }
            // .pos {
            //   position: absolute;
            //   width: 6%;
            //   img {
            //     width: 100%;
            //   }
            // }
            // .pos1 {
            //   top: 31%;
            //   left: 62%;
            // }
            // .pos2 {
            //   top: 28%;
            //   left: 81%;
            // }
            // .pos3 {
            //   top: 40%;
            //   left: 64%;
            // }
            // .pos4 {
            //   top: 62%;
            //   left: 56%;
            // }
            // .pos5 {
            //   top: 61%;
            //   left: 80%;
            // }
          }
          .cont-right {
            margin-top: 20px;
            width: 100%;
            display: flex;
            // flex-direction: column;
            // justify-content: center;
            justify-content: space-between;
            p {
              color: #333333;
            }
            p:last-child {
              float: right;
            }
            img {
              width: 100%;
              margin-top: 15px;
            }
          }
        }
      }
    }

    // 左侧导航条
    .el-menu-vertical {
      background-color: transparent;
      border-right: none;
      .el-menu-item {
        // font-size: 24px;
        // line-height: 33px;
        height: 0;
        padding-left: 0 !important;
        // margin-bottom: 52px;
        .side {
          display: inline-block;
          // height: 33px;
          // width: 6px;
          // margin-right: 20px;
        }
        .side-active {
          background-color: #0e6cb6;
        }
      }
      .el-menu-item.is-active {
        color: #0e6cb6;
      }
      .el-menu-item:focus,
      .el-menu-item:hover {
        background-color: transparent;
      }
    }
  }
  .horizontal-box {
    flex-direction: column;
    .horizontal-tabs {
      display: block;
      /deep/.el-tabs__header {
        margin-bottom: 20px;
        .el-tabs__nav {
          width: 100%;
          .el-tabs__item {
            width: 33%;
            text-align: center;
            padding: 0;
            color: #666666;
            &:hover {
              color: #0e6cb6;
            }
          }
          .el-tabs__item.is-active {
            color: #0e6cb6;
          }
          .el-tabs__active-bar {
            width: 20% !important;
            left: 6%;
            background-color: #0e6cb6;
          }
        }
      }
    }
    .el-menu-vertical {
      display: none;
    }
    .all-modules {
      padding-left: 0;
    }
  }
}

@media screen and (min-width: 1200px) {
  .el-menu-vertical {
    .el-menu-item {
      font-size: 24px;
      line-height: 33px;
      margin-bottom: 52px;
      .side {
        height: 33px;
        width: 6px;
        margin-right: 20px;
      }
    }
  }
  .core {
    .sec {
      width: 32%;
      margin-bottom: 12px;
    }
    .title {
      font-size: 22px;
      // min-height: 100px;
      color: #333;
      line-height: 52px;
      letter-spacing: 3px;
    }
    .hint {
      font-size: 16px;
    }
  }
  .recruitment {
    ul {
      li {
        width: 200px;
        padding: 16px;
        font-size: 20px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 40px;
        font-size: 22px;
        letter-spacing: 3px;
        margin-top: 12px;
      }
      div {
        line-height: 34px;
        font-size: 18px;
        letter-spacing: 3px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 546px;
      }
    }
    .cont-right {
      width: 28%;
      p {
        line-height: 32px;
        font-size: 20px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .el-menu-vertical {
    .el-menu-item {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 46px;
      .side {
        height: 30px;
        width: 6px;
        margin-right: 20px;
      }
    }
  }
  .core {
    .sec {
      width: 32%;
      margin-bottom: 12px;
    }
    .title {
      font-size: 18px;
      // min-height: 90px;
      color: #333;
      line-height: 32px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 16px;
    }
  }
  .recruitment {
    ul {
      li {
        width: 190px;
        padding: 16px;
        font-size: 16px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 40px;
        font-size: 18px;
        letter-spacing: 2px;
        margin-top: 12px;
      }
      div {
        line-height: 30px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 62%;
      #allmap {
        height: 420px;
      }
    }
    .cont-right {
      width: 32%;
      p {
        line-height: 26px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  /deep/ .el-tabs__nav {
    line-height: 40px !important;
    .el-tabs__item {
      font-size: 18px;
    }
  }
  .el-menu-vertical {
    .el-menu-item {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 46px;
      .side {
        height: 30px;
        width: 6px;
        margin-right: 16px;
      }
    }
  }
  .core {
    .sec {
      width: 48%;
      margin-bottom: 6px;
    }
    .title {
      font-size: 16px;
      // min-height: 56px;
      color: #333;
      line-height: 26px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 14px;
    }
  }
  .recruitment {
    ul {
      li {
        // width: 190px;
        padding: 8px;
        font-size: 14px;
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 2px;
        margin-top: 12px;
      }
      div {
        line-height: 24px;
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 300px;
        margin-bottom: 15px;
      }
    }
    .cont-right {
      width: 100%;
      p {
        line-height: 26px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
  /deep/ .el-tabs__nav {
    line-height: 30px !important;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-menu-vertical {
    width: 22%;
    .el-menu-item {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 30px;
      .side {
        height: 18px;
        width: 4px;
        margin-right: 8px;
      }
    }
  }
  .all-modules {
    width: 72%;
  }
  .core {
    .sec {
      width: 48%;
      margin-bottom: 6px;
    }
    .title {
      font-size: 12px;
      // min-height: 40px;
      color: #333;
      line-height: 18px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 12px;
    }
  }
  .recruitment {
    ul {
      li {
        // width: 190px;
        padding: 6px;
        font-size: 12px;
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 30px;
        font-size: 14px;
        letter-spacing: 1px;
        margin-top: 8px;
      }
      div {
        line-height: 20px;
        font-size: 12px;
        letter-spacing: 1spx;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 200px;
        margin-bottom: 15px;
      }
    }
    .cont-right {
      width: 100%;
      p {
        line-height: 22px;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
